<template>
  <div v-if="isLoading && !isError" class="text-center h-100 py-8">
    <div class="spinner-border spinner-size" role="status">
      <span class="visually-hidden fs-1">{{ $t('key_loading') }}</span>
    </div>
  </div>
   <div v-if="isEmpty && !isError" class="text-center">
    <i class="fa fa-info-circle empty-icon" aria-hidden="true" style="font-size: 3.5rem"></i>
    <h4 class="mt-2 text-primary">{{ $t('key_pod_no_files') }}</h4>
  </div>
  <div v-if="isError" class="text-center">
    <i class="fa fa-times-circle-o text-danger" aria-hidden="true" style="font-size: 3.5rem"></i>
    <h4 class="mt-2">{{ $t('key_pod_unable_to_load_resources') }}</h4>
  </div>
  <div v-if="!isLoading && !isError" id='gallery' class="gallery">
    <DocumentItem
      v-for="(doc, index) in documents"
      :key="`${index}-${doc['name']}`"
      :index='index'
      :document='doc'
      @show-error-notification='showErrorNotification'
      @request-delete="requestDelete"
      @remove="deleteItem"
      @download="downloadItem"
    />
  </div>
  <ModalDeleteConfirmation :entity='fileNameToDelete' @confirm-delete="deleteItem" />
</template>
<script>
import ModalDeleteConfirmation from "./ModalDeleteConfirmation.vue";
import DocumentItem from './DocumentItem'

export default {
  name: "DocumentList",
  components: {
    DocumentItem,
    ModalDeleteConfirmation
  },
  props: {
    documents: {
      type: Array,
      default: () => {
        return [];
      },
    },
    manifestId: {
      type: String,
      default: '',
    },
  },
  emits: ['show-error-notification'],
  data() {
    return {
      gallery: [],
      fileNameToDelete: null,
      isLoading: true,
      isError: false,
      isEmpty: false,
    }
  },
  computed: {
    errors() {
      return this.$store.state.manifiest.manifestResources.status;
    },
  },
  watch: {
    documents() {
      this.$forceUpdate()
      if(this.documents) {
        this.isLoading = false
        if (this.documents.length == 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
      } else {
        this.isLoading = true
        this.isEmpty = false
      }
    },
    // eslint-disable-next-line no-unused-vars
    errors(value) {
      if(!this.errors['loaded']){
        this.isLoading = false
        this.isError = true
      }
    },
  },
  mounted() {},
  methods: {
    showErrorNotification(message) {
      this.$emit('show-error-notification', message)
    },
    getDocumentName(value) {
      const name = value.split('/')[2]
      return name
    },
    requestDelete(value) {
      this.fileNameToDelete = { ...value }
    },
    deleteItem(value) {
      this.$store.commit("manifiest/deleteResource", { entityId: this.manifestId, file: value });
    },
    downloadItem(value) {
      const fileName = value['name'].split('/')[2]
      this.$store.commit("manifiest/downloadResource", { entityId: this.manifestId, fileName: fileName });
    },
    handleFilesChanged(value) {
      let dataForm = new FormData();
      dataForm.append('file', value);

      this.$store.commit("manifiest/uploadResource", { entityId: this.manifestId, dataForm });
    }
  }
};
</script>
<style scoped lang="scss">

.empty-icon {
  color: #4A7062
}

.spinner-size {
  width: 3rem;
  height: 3rem;
}

.loading-spinner {
  position: absolute;
  top: 16rem;
  left: 20rem;
}

.gallery {
  flex: auto;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  margin: 0rem;
}
</style>